<template>
  <FormulateForm
    class="login-form"
    v-model="formValues"
    @submit="submitHandler"
  >
    <h3 class="form-title">Importante</h3>
    <p>
      {{ this.$route.params.mensaje }}
    </p>
    
    <FormulateInput type="submit" name="Aceptar" />

  </FormulateForm>
</template>

<script>
export default {
  data () {
    return {
      formValues: {}
    }
  },

  created() {
    console.log(this.$route.params.mensaje)
    if (this.$route.params.mensaje == null) {
      window.location.href = "https://www.bancojulio.com.ar";
    }
  },

  methods: {
    submitHandler() {
      window.location.href = "https://www.bancojulio.com.ar";
    },
  },
}
</script>

<style scoped>
.login-form {
  padding: 2em;
  border: 1px solid #a8a8a8;
  border-radius: .5em;
  margin: 3rem auto;
  width: 60%;
  min-width: 450px;
  max-width: 100%;
  box-sizing: border-box;
  justify-content: center;
  display: flex;
  flex-direction: column;
}
.form-title {
  margin-top: 0;
}
.login-form::v-deep .formulate-input .formulate-input-element {
  max-width: none;
}

</style>
